import { useState, type FormEvent } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, Field, Input, PageHead, useToast } from '@w7/ui'
import { sessionApi } from '@/api/sessionApi'

export function ChangePasswordPage() {
  const toast = useToast()
  const navigate = useNavigate()
  const [form, setForm] = useState({ password: '', newPassword: '', confirmPassword: '' })

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault()
    if (form.newPassword !== form.confirmPassword) {
      toast.error('Password and Confirm Password should be same!')
      return
    }
    try {
      const res = await sessionApi.changePassword({
        password: form.password,
        newPassword: form.newPassword,
        confirmPassword: form.confirmPassword,
      })
      if (res.status === 200) {
        toast.success('Passsword Changed Successfully')
        navigate('/sessionmarket')
      } else toast.error('Something Went Wrong')
    } catch {
      toast.error('Something Went Wrong')
    }
  }

  return (
    <div>
      <PageHead title="Change Password" onBack={() => navigate('/sessionmarket')} />
      <form className="sm-card" style={{ maxWidth: 520 }} onSubmit={(e) => void onSubmit(e)}>
        <Field label="Old Password">
          {({ id, describedBy, invalid }) => (
            <Input
              id={id}
              aria-describedby={describedBy}
              invalid={invalid}
              type="password"
              value={form.password}
              onChange={(e) => setForm((f) => ({ ...f, password: e.target.value }))}
              required
            />
          )}
        </Field>
        <Field label="New Password">
          {({ id, describedBy, invalid }) => (
            <Input
              id={id}
              aria-describedby={describedBy}
              invalid={invalid}
              type="password"
              value={form.newPassword}
              onChange={(e) => setForm((f) => ({ ...f, newPassword: e.target.value }))}
            />
          )}
        </Field>
        <Field label="Confirm Password">
          {({ id, describedBy, invalid }) => (
            <Input
              id={id}
              aria-describedby={describedBy}
              invalid={invalid}
              type="password"
              value={form.confirmPassword}
              onChange={(e) => setForm((f) => ({ ...f, confirmPassword: e.target.value }))}
            />
          )}
        </Field>
        <Button
          type="submit"
          variant="primary"
          disabled={!form.password || !form.newPassword || !form.confirmPassword}
          style={{ marginTop: 12 }}
        >
          Update
        </Button>
      </form>
    </div>
  )
}
